<section class="ds-modal view-files-modal" data-testid="viewFilesModal">
    <div class="ds-modal__header view-files-modal__header">
        <ds-title size="sm" text="View Files" weight="semibold"></ds-title>

        <ds-icon-button
            icon="close"
            size="sm"
            theme="tertiary-gray"
            title="Close"
            data-testid="viewFilesModalCancelButton"
            (buttonClick)="dialogRef.close(hasChanges)"
        ></ds-icon-button>
    </div>

    <ds-loading-bar *ngIf="isLoading" class="progress-loader-v2"></ds-loading-bar>

    <div class="ds-modal__content ds-modal__content--scrollable view-files-modal__content">
        <form *ngIf="!isReadOnly" class="view-files-modal__filters" [formGroup]="filtersForm">
            <ds-input
                class="view-files-modal__filter"
                formControlName="search"
                data-testid="viewFilesModalSearch"
                label="Search"
                placeholder="By Name"
            >
                <span prefix>
                    <mat-icon fontSet="material-symbols-rounded">search</mat-icon>
                </span>
            </ds-input>

            <ds-select
                class="view-files-modal__filter"
                formControlName="fileType"
                data-testid="viewFilesModalFileType"
                label="File Type"
                placeholder="All"
                panelClass="file-type-select-panel"
                [compareWith]="compareById"
                [options]="fileTypeOptions"
            ></ds-select>
        </form>

        <div class="view-files-modal__toolbar">
            <div class="view-files-modal__total">
                <ds-text size="sm" text="Total Files:" theme="primary" weight="semibold"></ds-text>
                <app-ds-badge icon="upload" size="sm" [label]="totalCount.toString()"></app-ds-badge>
            </div>

            <div class="view-files-modal__actions">
                <input
                    id="vendorDetailFile"
                    data-testid="viewFilesModalInput"
                    class="view-files-modal__file-input"
                    #fileInput
                    multiple
                    name="multipleFilePopup"
                    type="file"
                    [accept]="acceptAttribute"
                    (input)="onFilesSelected($event)"
                />

                <ds-button
                    *ngIf="isAddButtonVisible"
                    data-testid="viewFilesModalAddFileButton"
                    icon="upload"
                    label="Add File"
                    size="sm"
                    (buttonClick)="openFilePicker()"
                ></ds-button>

                <ds-button
                    *ngIf="isBulkEditButtonVisible"
                    data-testid="viewFilesModalBulkEditButton"
                    icon="edit"
                    label="Bulk edit"
                    size="sm"
                    theme="secondary"
                    (buttonClick)="startBulkEdit()"
                ></ds-button>

                <ds-icon-button
                    *ngIf="isBulkEditActive"
                    icon="close"
                    size="sm"
                    data-testid="viewFilesModalBulkCancelButton"
                    matTooltip="Cancel bulk edit"
                    matTooltipPosition="above"
                    matTooltipShowDelay="300"
                    theme="secondary-gray"
                    (buttonClick)="cancelBulkEdit()"
                ></ds-icon-button>

                <ds-icon-button
                    *ngIf="isBulkEditActive"
                    icon="check"
                    size="sm"
                    data-testid="viewFilesModalSaveButton"
                    matTooltip="Save all files"
                    matTooltipPosition="above"
                    matTooltipShowDelay="300"
                    theme="secondary"
                    [isDisabled]="isSaving"
                    (buttonClick)="saveFiles()"
                ></ds-icon-button>
            </div>
        </div>

        <div *ngIf="!isLoading" class="view-files-modal__table-wrapper">
            <table
                mat-table
                matSort
                matSortDisableClear
                class="view-files-modal__table"
                data-testid="viewFilesModalTable"
                matSortActive="fileName"
                matSortDirection="desc"
                matSortStart="desc"
                [dataSource]="displayedFiles"
                [trackBy]="trackByFn"
                (matSortChange)="onSortChange($event)"
            >
                <ng-container matColumnDef="fileName">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>File Name</th>
                    <td *matCellDef="let file; let i = index" mat-cell>
                        <ng-container *ngIf="!file.isEditable; else fileNameEditTemplate">
                            <div class="view-files-modal__file-name">
                                <a class="view-files-modal__file-link" data-testid="viewFilesModalFileName" (click)="downloadFile(file)">{{
                                    file.displayName || file.fileName
                                }}</a>

                                <app-ds-badge
                                    *ngIf="file?.uploadedFrom | fileOriginBadge as badge"
                                    size="sm"
                                    [label]="badge.label"
                                    [theme]="badge.theme"
                                ></app-ds-badge>
                            </div>
                        </ng-container>

                        <ng-template #fileNameEditTemplate>
                            <ds-input
                                *ngIf="getRowForm(file) as rowForm"
                                id="file_name_edit{{ i }}"
                                class="view-files-modal__name-input"
                                data-testid="viewFilesModalFileNameInput"
                                placeholder="File Name"
                                [formControl]="rowForm.controls.baseName"
                            >
                                <span *ngIf="file.extension" suffix class="view-files-modal__extension">.{{ file.extension }}</span>
                            </ds-input>
                        </ng-template>
                    </td>
                </ng-container>

                <ng-container matColumnDef="createdOn">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Uploaded On</th>
                    <td *matCellDef="let file" mat-cell>
                        <ng-container *ngIf="file?.createdOn; else emptyCellTemplate">{{ file?.createdOn | ToLocalDate }}</ng-container>
                    </td>
                </ng-container>

                <ng-container matColumnDef="fileAttachmentTagName">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>File Tags</th>
                    <td *matCellDef="let file; let i = index" mat-cell>
                        <ng-container *ngIf="file.isEditable">
                            <ds-select
                                *ngIf="getRowForm(file) as rowForm"
                                id="file-tag{{ i }}"
                                class="view-files-modal__tag-select"
                                data-testid="viewFilesModalTagSelect"
                                placeholder="Select file attachment tag"
                                panelClass="file-tag-select-panel"
                                [compareWith]="compareById"
                                [formControl]="rowForm.controls.fileAttachmentTag"
                                [options]="tagOptions"
                            ></ds-select>
                        </ng-container>

                        <app-ds-badge
                            *ngIf="!file.isEditable && file?.fileAttachmentTagName"
                            class="view-files-modal__tag-badge"
                            data-testid="viewFilesModalTagBadge"
                            size="sm"
                            [label]="file.fileAttachmentTagName"
                            [theme]="file.fileAttachmentTagName | fileTagBadgeTheme"
                        ></app-ds-badge>
                    </td>
                </ng-container>

                <ng-container matColumnDef="creatorName">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Created By</th>
                    <td *matCellDef="let file" mat-cell>
                        <ng-container *ngIf="file?.creatorName; else emptyCellTemplate">{{ file?.creatorName }}</ng-container>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th *matHeaderCellDef mat-header-cell>Action</th>
                    <td *matCellDef="let file" mat-cell>
                        <div class="view-files-modal__row-actions">
                            <ds-icon-button
                                *ngIf="!file.isEditable"
                                class="view-files-modal__pin"
                                data-testid="viewFilesModalPinButton"
                                icon="star"
                                size="sm"
                                matTooltipPosition="above"
                                matTooltipShowDelay="300"
                                theme="tertiary-gray"
                                [isDisabled]="isReadOnly"
                                [matTooltip]="file?.isPinned ? 'Remove priority' : 'Add priority'"
                                [ngClass]="{ 'view-files-modal__pin--active': file?.isPinned }"
                                (buttonClick)="togglePin(file)"
                            ></ds-icon-button>

                            <ds-icon-button
                                *ngIf="!file.isEditable"
                                icon="edit"
                                size="sm"
                                data-testid="viewFilesModalEditButton"
                                matTooltip="Edit file name and tag"
                                matTooltipPosition="above"
                                matTooltipShowDelay="300"
                                theme="tertiary-gray"
                                [isDisabled]="isReadOnly"
                                (buttonClick)="startFileEdit(file)"
                            ></ds-icon-button>

                            <ng-container *ngIf="!isCustomerOrVendorCoordinator && data.isFileEditable">
                                <ds-icon-button
                                    *ngIf="!file.isEditable"
                                    icon="delete"
                                    size="sm"
                                    data-testid="viewFilesModalDeleteButton"
                                    matTooltip="Delete file"
                                    matTooltipPosition="above"
                                    matTooltipShowDelay="300"
                                    theme="tertiary-gray"
                                    [isDestructive]="true"
                                    [isDisabled]="isReadOnly"
                                    (buttonClick)="removeFile(file)"
                                ></ds-icon-button>
                            </ng-container>

                            <ds-icon-button
                                *ngIf="file.isEditable"
                                icon="check"
                                size="sm"
                                data-testid="viewFilesModalRowSaveButton"
                                matTooltip="Save file"
                                matTooltipPosition="above"
                                matTooltipShowDelay="300"
                                theme="tertiary-gray"
                                [isDisabled]="isSaving"
                                (buttonClick)="saveFile(file)"
                            ></ds-icon-button>

                            <ds-icon-button
                                *ngIf="file.isEditable"
                                icon="close"
                                size="sm"
                                data-testid="viewFilesModalRowCancelButton"
                                matTooltip="Cancel editing"
                                matTooltipPosition="above"
                                matTooltipShowDelay="300"
                                theme="tertiary-gray"
                                [isDisabled]="isSaving"
                                (buttonClick)="cancelFileEdit(file)"
                            ></ds-icon-button>
                        </div>
                    </td>
                </ng-container>

                <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
                <tr
                    *matRowDef="let row; let rowIndex = index; columns: displayedColumns"
                    mat-row
                    [attr.data-testid]="'viewFilesModalRow-' + rowIndex"
                ></tr>
            </table>
        </div>

        <div *ngIf="!displayedFiles.length && !isLoading" class="view-files-modal__empty" data-testid="viewFilesModalEmpty">
            <mat-icon fontSet="material-symbols-rounded">folder_open</mat-icon>
            <ds-title size="xs" text="No record found!" weight="semibold"></ds-title>
            <ds-text size="sm" theme="secondary" [text]="emptyStateDescription"></ds-text>
        </div>

        <div *ngIf="displayedFiles.length && filteredCount && !isLoading" class="view-files-modal__pagination">
            <app-table-pagination-info
                [currentPageNumber]="currentPage"
                [itemsPerPage]="pageSize"
                [itemsTotalCount]="filteredCount"
            ></app-table-pagination-info>

            <app-table-pagination
                [currentPageNumber]="currentPage"
                [itemsPerPage]="pageSize"
                [totalItemsCount]="filteredCount"
                (currentPageNumberChange)="onPageChange($event)"
            ></app-table-pagination>
        </div>
    </div>
</section>

<ng-template #emptyCellTemplate>
    <ds-text size="sm" text="—" theme="tertiary"></ds-text>
</ng-template>
